module.exports = __webpack_public_path__ + "static/stormking-ed52d20fda274aa6fa16678a619c41f7.jpg";